exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".global-error{\n    width: 100%;\n    color: red;\n    margin: 0;\n}\n.global-success{\n    width: 100%;\n    color: green;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/illumine/desktop/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main